import Footer from "./layout/Footer";
import Head from "./partner/Head";
import Banner from "./partner/Banner";
import Partner from "./partner/Partner";
import Media from "./partner/Media";
import Article from "./partner/Article";

const Parner = () => {

    return (
        <div className="overflow-hidden font-jasa">
            <Head/>
            <Banner/>
            <Partner/>
            <Article/>
            <Media/>
            <Footer/>
        </div>
    );
};

export default Parner;
